import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useHeight } from "../hooks/index.js";
import { ReactPlayer } from "./ReactPlayer.js";
const PlayerComponent = (t0)=>{
    const $ = c(4);
    const { src, description, editable } = t0;
    const { maxHeight, editorHeight } = useHeight();
    const height = editable ? editorHeight : maxHeight;
    let t1;
    if ($[0] !== description || $[1] !== height || $[2] !== src) {
        t1 = /*#__PURE__*/ jsx(ReactPlayer, {
            src: src,
            description: description,
            width: "100%",
            height: height,
            controls: true,
            preload: "metadata",
            autoPlay: false
        });
        $[0] = description;
        $[1] = height;
        $[2] = src;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
export { PlayerComponent };
